import React from 'react';
import { WithIntlProps } from 'react-intl';
import {
  ContentSwitcher,
  ContentSwitcherProps,
  ContentSwitcherDataProps,
} from '@xingternal/content-switcher';
import { useTracking } from '@/hooks/useTracking';

export interface BaseContentSwitcherDataProps extends ContentSwitcherDataProps {
  to?: string;
  href?: string;
  trackingAttributes?: {
    [key: string]: string;
  };
}

export interface BaseContentSwitcherProps
  extends WithIntlProps<ContentSwitcherProps> {
  data: Array<BaseContentSwitcherDataProps>;
}

const BaseContentSwitcher: React.FC<BaseContentSwitcherProps> = ({
  data,
  ...props
}) => {
  const { generateHandleTracking } = useTracking();

  const dataWithTracking = data.map(
    ({ trackingAttributes, onClick, ...other }) => {
      const handleTracking = generateHandleTracking({
        onClick,
        href: other.href,
        to: other.to,
        trackingAttributes,
      });

      return {
        ...other,
        href: other.to || other.href,
        onClick: trackingAttributes ? handleTracking : onClick,
      };
    },
  );

  return <ContentSwitcher {...{ ...props, data: dataWithTracking }} />;
};

export default BaseContentSwitcher;
